if (!("ontouchstart" in document.documentElement)) {
	document.documentElement.className += " no-touch";
}

jQuery(function($){
  updateCartStuff();

  resizeWindow();

  $(window).resize(resizeWindow);

  // Refresh cart upsells by re-rendering the cart-drawer section via
  // Shopify's Section Rendering API (section_id) and swapping in the new upsell block.
  // Expose on window so it can be called from global functions.
  window.updateCartUpsells = function () {
    try {
      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + '?section_id=cart-drawer'
        : window.location.pathname + '?section_id=cart-drawer';

      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          if (!html) return;

          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;

          // The section HTML will include the section wrapper; find upsells inside it
          var newSection = wrapper.querySelector('#shopify-section-cart-drawer') || wrapper.firstElementChild;
          if (!newSection) return;

          var newUpsells = newSection.querySelector('.upsell-items');
          if (!newUpsells) return;

          // Find current upsell container in the existing DOM
          var currentSection = document.getElementById('shopify-section-cart-drawer');
          var currentUpsells = currentSection
            ? currentSection.querySelector('.upsell-items')
            : document.querySelector('#cart .upsell-items');

          if (currentUpsells) {
            currentUpsells.replaceWith(newUpsells);
          } else if (currentSection) {
            currentSection.appendChild(newUpsells);
          }
        })
        .catch(function (err) {
          console.error('Error refreshing cart upsells section:', err);
        });
    } catch (e) {
      console.error('Error initializing cart upsells refresh:', e);
    }
  };


  // Set tab order on mobile: hamburger, search, logo, cart
  function setMobileTabOrder() {
    if ($(window).width() <= 1024) {
      // Mobile: set explicit tab order
      $(".toggle_nav").attr("tabindex", "1");
      $(".show_1024 .toggle_search").attr("tabindex", "2");
      $(".navigation-logo a.logo-link").attr("tabindex", "3");
      $(".navigation-icons .toggle_cart").attr("tabindex", "4");
      $(".navigation-icons .navigation__icon a").not(".toggle_cart").attr("tabindex", "5");
    } else {
      // Desktop: remove explicit tab order
      $(".toggle_nav").attr("tabindex", "0");
      $(".show_1024 .toggle_search").attr("tabindex", "0");
      $(".navigation-logo a.logo-link").attr("tabindex", "0");
      $(".navigation-icons .toggle_cart").attr("tabindex", "0");
      $(".navigation-icons .navigation__icon a").attr("tabindex", "0");
    }
  }
  
  setMobileTabOrder();
  $(window).on("resize", setMobileTabOrder);

  // mobile nav
  var lastFocusedElement;
  
  $(".toggle_nav").on("click tap", function (e) {
    e.stopPropagation();
    e.preventDefault();
    if ($("#mobile_nav").hasClass("open")) {
      // Close mobile nav
      $(".toggle_nav .hamburger").removeClass("open");
      $("#mobile_nav").removeClass("open");
      $("body").removeClass("lock");
      $(".toggle_nav").attr("aria-expanded", "false");
      
      // Return focus to toggle button
      if (lastFocusedElement) {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }
    } else {
      // Open mobile nav
      lastFocusedElement = document.activeElement;
      $(".toggle_nav .hamburger").addClass("open");
      $("#mobile_nav").addClass("open");
      $("body").addClass("lock");
      $(".toggle_nav").attr("aria-expanded", "true");
      
      if ($("#search_bar").hasClass("open")) {
        $("#search_bar").removeClass("open");
        if ($("#search_bar-results").length) {
          $("#search_bar-results").html("");
        }
      }
      
      // Focus first focusable element in mobile nav
      setTimeout(function() {
        $("#mobile_nav").find("a, button").first().focus();
      }, 100);
    }
  });
  
  // Focus trap for mobile nav (includes header)
  $(document).on("keydown", function(e) {
    if (!$("#mobile_nav").hasClass("open")) return;
    
    if (e.key === "Tab" || e.keyCode === 9) {
      // Get all focusable elements in header and mobile nav
      var headerFocusable = $("#header .show_1024").find("a:visible, button:visible").filter(function() {
        return $(this).is(":visible") && !$(this).is(":disabled") && $(this).attr("tabindex") !== "-1";
      });
      
      var mobileNavFocusable = $("#mobile_nav").find("a:visible, button:visible").filter(function() {
        return $(this).is(":visible") && !$(this).is(":disabled");
      });
      
      var allFocusable = headerFocusable.add(mobileNavFocusable);
      var firstFocusable = allFocusable.first()[0];
      var lastFocusable = allFocusable.last()[0];
      
      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
    
    // Escape key to close
    if (e.key === "Escape" || e.keyCode === 27) {
      if ($("#mobile_nav").hasClass("open")) {
        $(".toggle_nav").trigger("click");
      }
    }
  });
  
  // Helper function to update mobile nav ARIA attributes
  function updateMobileNavAria($parent, isOpen) {
    var $toggler = $parent.find("a.toggler");
    var $dropdown = $parent.find(".dropdown");
    if ($toggler.length) {
      $toggler.attr("aria-expanded", isOpen ? "true" : "false");
    }
    if ($dropdown.length) {
      $dropdown.attr("aria-hidden", isOpen ? "false" : "true");
    }
  }

  $("#mobile_nav .nav li.has_children a.toggler").on("click tap", function (e) {
    // Check if click was on SVG or its children
    if ($(e.target).closest('svg').length || $(e.target).closest('.plusminus-wrapper').length) {
      return; // Let SVG handler deal with it
    }
    
    var $parent = $(this).parent();
    
    // If parent already has 'open' class, close it and force navigation/reload
    if ($parent.hasClass('open')) {
      e.stopPropagation();
      e.preventDefault();
      $parent.removeClass("open");
      $(this).next(".dropdown").slideUp("fast");
      updateMobileNavAria($parent, false);
      // Force page load/reload by navigating to the href
      window.location.href = $(this).attr('href');
      return false;
    }
    
    // Otherwise, prevent default and toggle
    e.stopPropagation();
    e.preventDefault();
    
    // Close other open dropdowns and update ARIA
    $("#mobile_nav .nav li.has_children.open").each(function() {
      updateMobileNavAria($(this), false);
    }).removeClass("open").find(".dropdown").slideUp("fast");
    
    $parent.addClass("open");
    $(this).next(".dropdown").slideDown("fast");
    updateMobileNavAria($parent, true);
  });

  // Keyboard support for mobile nav togglers
  $("#mobile_nav .nav li.has_children a.toggler").on("keydown", function (e) {
    // Enter or Space key
    if (e.key === "Enter" || e.keyCode === 13 || e.key === " " || e.keyCode === 32) {
      var $parent = $(this).parent();
      
      // If clicking on the icon/plusminus, toggle without navigation
      if ($(e.target).closest('.plusminus-wrapper').length) {
        e.preventDefault();
        e.stopPropagation();
        
        // Close other open dropdowns
        if (!$parent.hasClass('open')) {
          $("#mobile_nav .nav li.has_children.open").each(function() {
            updateMobileNavAria($(this), false);
          }).removeClass("open").find(".dropdown").slideUp("fast");
        }
        
        // Toggle this dropdown
        $parent.toggleClass("open");
        $(this).next(".dropdown").slideToggle("fast");
        updateMobileNavAria($parent, $parent.hasClass('open'));
        return false;
      }
      
      // If already open, navigate
      if ($parent.hasClass('open')) {
        // Let default behavior happen (follow link)
        return true;
      }
      
      // Otherwise open the dropdown
      e.preventDefault();
      e.stopPropagation();
      
      $("#mobile_nav .nav li.has_children.open").each(function() {
        updateMobileNavAria($(this), false);
      }).removeClass("open").find(".dropdown").slideUp("fast");
      
      $parent.addClass("open");
      $(this).next(".dropdown").slideDown("fast");
      updateMobileNavAria($parent, true);
    }
  });

  // SVG/plusminus click handler - toggle accordion without navigation
  $("#mobile_nav .nav li.has_children a.toggler svg, #mobile_nav .nav li.has_children a.toggler svg *, #mobile_nav .nav li.has_children a.toggler .plusminus-wrapper").on("click tap", function (e) {
    e.stopPropagation();
    e.preventDefault();
    
    var $parent = $(this).closest("li.has_children");
    
    // Close other open dropdowns if this one is being opened
    if (!$parent.hasClass('open')) {
      $("#mobile_nav .nav li.has_children.open").each(function() {
        updateMobileNavAria($(this), false);
      }).removeClass("open").find(".dropdown").slideUp("fast");
    }
    
    // Toggle this dropdown
    $parent.toggleClass("open");
    $(this).closest("a.toggler").next(".dropdown").slideToggle("fast");
    updateMobileNavAria($parent, $parent.hasClass('open'));
  });

  // search toggle
  $(".toggle_search").on("click tap", function (e) {
    e.stopPropagation();
    e.preventDefault();
    if ($("#search_bar").hasClass("open")) {
      $("#search_bar").removeClass("open");
      if ($("#search_bar-results").length) {
        $("#search_bar-results").html("");
      }
    } else {
      $("#search_bar").addClass("open");
      if ($("#mobile_nav").hasClass("open")) {
        $(".toggle_nav .hamburger").removeClass("open");
        $("#mobile_nav").removeClass("open");
      }
    }

    // create invisible dummy input to receive the focus first
    const fakeInput = document.createElement("input");
    fakeInput.setAttribute("type", "text");
    fakeInput.style.position = "absolute";
    fakeInput.style.opacity = 0;
    fakeInput.style.height = 0;
    fakeInput.style.fontSize = "16px"; // disable auto zoom

    // you may need to append to another element depending on the browser's auto
    // zoom/scroll behavior
    document.getElementById("header").prepend(fakeInput);

    // focus so that subsequent async focus will work
    fakeInput.focus();

    setTimeout(() => {
      // now we can focus on the target input
      $("#search_bar-input").focus();

      // cleanup
      fakeInput.remove();
    }, 150);
  });

  //desktop shop dropdowns
  if ($(".hide_1024 .shop-link .dropdown").length) {
    // Initialize - make all dropdown links not tabbable by default
    $("#header .hide_1024 .dropdown a").attr("tabindex", "-1");
    
    // Helper function to manage tabindex
    function setDropdownTabindex($dropdown, isActive) {
      $dropdown.find("a").attr("tabindex", isActive ? "0" : "-1");
    }
    
    // Helper function to update ARIA attributes
    function updateAriaAttributes($parent, isOpen) {
      var $button = $parent.find("button");
      if ($button.length) {
        $button.attr("aria-expanded", isOpen ? "true" : "false");
      }
      var $dropdown = $parent.find(".dropdown");
      if ($dropdown.length) {
        $dropdown.attr("aria-hidden", isOpen ? "false" : "true");
      }
    }
    
    // Mouse hover handling
    $(
      "#header .hide_1024 > ul > li, #header .logo, #header .cell > ul > li"
    ).on("mouseenter", function () {
      var $parent = $(this);
      if ($parent.hasClass("has-dropdown")) {
        if ($parent.find(".dropdown").length) {
          var triggerId = $parent.attr('id');
          var dropdownId = triggerId.replace('meganav-trigger', 'meganav-dropdown');
          
          // Make previously active dropdown links not tabbable and update ARIA
          $("#header .hide_1024 > ul > li.has-dropdown.dropdown--active").each(function() {
            setDropdownTabindex($(this).find(".dropdown"), false);
            updateAriaAttributes($(this), false);
          });
          
          $(".dropdown--active").removeClass("dropdown--active");
          $parent.addClass("dropdown--active");
          $("#" + dropdownId).addClass("dropdown--active");
          
          // Make newly active dropdown links tabbable and update ARIA
          setDropdownTabindex($("#" + dropdownId), true);
          updateAriaAttributes($parent, true);
        }
      } else {
        // Make dropdown links not tabbable when closing and update ARIA
        $("#header .hide_1024 > ul > li.has-dropdown.dropdown--active").each(function() {
          setDropdownTabindex($(this).find(".dropdown"), false);
          updateAriaAttributes($(this), false);
        });
        $(".dropdown--active").removeClass("dropdown--active");
      }
    });
    
    $("#header").on("mouseleave", function () {
      // Make all dropdown links not tabbable when closing and update ARIA
      $("#header .hide_1024 > ul > li.has-dropdown.dropdown--active").each(function() {
        setDropdownTabindex($(this).find(".dropdown"), false);
        updateAriaAttributes($(this), false);
      });
      $("#header .hide_1024 ul > li").removeClass("dropdown--active");
    });

    // Keyboard accessibility - Enter/Space key to toggle dropdown
    $("#header .hide_1024 > ul > li.has-dropdown > button").on("keydown", function (e) {
      if (e.key === "Enter" || e.keyCode === 13 || e.key === " " || e.keyCode === 32) {
        e.preventDefault();
        var $parent = $(this).parent();
        var triggerId = $parent.attr('id');
        var dropdownId = triggerId.replace('meganav-trigger', 'meganav-dropdown');
        var $dropdown = $("#" + dropdownId);
        
        // Toggle the dropdown
        if ($parent.hasClass("dropdown--active")) {
          // Close dropdown
          setDropdownTabindex($dropdown, false);
          updateAriaAttributes($parent, false);
          $(".dropdown--active").removeClass("dropdown--active");
        } else {
          // Close other dropdowns and make their links not tabbable
          $("#header .hide_1024 > ul > li.has-dropdown.dropdown--active").each(function() {
            setDropdownTabindex($(this).find(".dropdown"), false);
            updateAriaAttributes($(this), false);
          });
          $(".dropdown--active").removeClass("dropdown--active");
          
          // Open dropdown and make links tabbable
          $parent.addClass("dropdown--active");
          $dropdown.addClass("dropdown--active");
          setDropdownTabindex($dropdown, true);
          updateAriaAttributes($parent, true);
          
          // Focus first link in dropdown after a short delay
          setTimeout(function() {
            $dropdown.find("a").first().focus();
          }, 50);
        }
      }
    });

    // Prevent button click from closing dropdown when using mouse
    $("#header .hide_1024 > ul > li.has-dropdown > button").on("click", function (e) {
      e.preventDefault();
    });

    // Escape key to close dropdowns
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        if ($(".dropdown--active").length) {
          // Make dropdown links not tabbable and update ARIA
          $("#header .hide_1024 > ul > li.has-dropdown.dropdown--active").each(function() {
            setDropdownTabindex($(this).find(".dropdown"), false);
            updateAriaAttributes($(this), false);
          });
          
          $(".dropdown--active").removeClass("dropdown--active");
          
          // Return focus to the parent button
          $("#header .hide_1024 > ul > li.has-dropdown > button:focus").focus();
        }
      }
    });

    // Close dropdown when tabbing out of it
    $("#header .hide_1024 .dropdown a, #header .hide_1024 > ul > li.has-dropdown > button").on("blur", function (e) {
      var $this = $(this);
      setTimeout(function() {
        var $focusedElement = $(document.activeElement);
        var $activeParent = $this.closest("li.has-dropdown");
        
        // Check if focus is still within the same dropdown or its trigger button
        var focusInSameDropdown = $focusedElement.closest("li.has-dropdown").is($activeParent);
        var focusInAnyDropdown = $focusedElement.closest(".dropdown").length > 0;
        var focusOnButton = $focusedElement.is("button") && $focusedElement.parent().hasClass("has-dropdown");
        
        // Only close if focus moved completely outside the dropdown and its button
        if (!focusInSameDropdown && !focusOnButton) {
          // Make dropdown links not tabbable when closing and update ARIA
          $("#header .hide_1024 > ul > li.has-dropdown.dropdown--active").each(function() {
            setDropdownTabindex($(this).find(".dropdown"), false);
            updateAriaAttributes($(this), false);
          });
          $(".dropdown--active").removeClass("dropdown--active");
        }
      }, 10);
    });
  }

  // newsletter popup
  if ($("#newsletter").length) {
    if (typeof Storage !== "undefined") {
      if (sessionStorage.leMelShowNewsletter != 1) {
        setTimeout(function () {
          $("#newsletter").fadeIn(300);
        }, 1500);
      }
    }
  }
  $("#newsletter .close").on("click tap", function () {
    $("#newsletter").fadeOut(300, function () {
      sessionStorage.leMelShowNewsletter = 1;
    });
  });

  // paroller
  if ($(".paroller").length) {
    $(".paroller").paroller();
  }

  // product zoom images
  if ($("#product a[data-lightbox]").length) {
    lightbox.option({
      disableScrolling: true,
      showImageNumberLabel: false,
      positionFromTop: 30,
      fadeDuration: 300,
      imageFadeDuration: 300,
      resizeDuration: 100,
    });
  }

  // product wishlist trigger
  $("#product .main-product__wishlist a.wishlist.add, #product .product-form .actions a.wishlist.add").on(
    "click tap",
    function (e) {
      e.preventDefault();
      $("#product .main-product__wishlist a.wishlist.add, #product .product-form .actions a.wishlist.add").addClass("hidden");
      $("#product .main-product__wishlist a.wishlist.view, #product .product-form .actions a.wishlist.view").removeClass(
        "hidden"
      );
      $("button.swym-add-to-wishlist").trigger("click");
    }
  );

  // product drop a hint trigger
  $("#product .product-form .actions a.hint").on("click tap", function (e) {
    e.preventDefault();
    $("a.dp_hint_button").trigger("click");
  });

  // product details tabs
  $("#product .details .tabs .tab-nav span").on("click tap", function () {
    $("#product .details .tabs .tab-nav span").removeClass("active");
    $(this).addClass("active");
    var rel = $(this).attr("rel");
    $("#product .details .tabs .tab-content .tab").hide(0);
    $("#product .details .tabs .tab-content .tab.tab-" + rel).show(0);
  });

  // product details slider
  if ($("#product .details .slider").length) {
    $("#product .details .slider")
      .imagesLoaded()
      .always(function () {
        $("#product .details .slider").slick({
          infinite: true,
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: 0,
        });
      });
  }
  
  // guides page nav
  $("#guides_page .nav a").on("click tap", function (e) {
    e.preventDefault();
    var rel = $(this).attr("rel");
    $("html, body").animate(
      {
        scrollTop: $("#guides_page .sections .section.section-" + rel).offset()
          .top,
      },
      600
    );
  });

  // faqs
  $("#faqs .sections .sidebar ul li a").on("click tap", function (e) {
    e.preventDefault();
    var rel = $(this).attr("rel");
    $("#faqs .sections .sidebar ul li a").removeClass("active");
    $(this).addClass("active");
    $("#faqs .sections .content .section").hide(0);
    $("#faqs .sections .content .section.section-" + rel).show(0);
  });
  $("#faqs .sections .content .faqs .faq .question").on(
    "click tap",
    function () {
      $(this).toggleClass("open").next(".answer").slideToggle("fast");
    }
  );

  // wholesale faqs
  $(".wholesale-faqs .faqs .faq .question").on("click tap", function () {
    $(this).toggleClass("open").next(".answer").slideToggle("fast");
  });

  // piercing faqs
  $(".piercing-faqs .faqs .faq .question").on("click tap", function () {
    $(this).toggleClass("open").next(".answer").slideToggle("fast");
  });

  // cart toggle
  var lastFocusedElementBeforeCart;
  
  $(".toggle_cart").on("click tap", function (e) {
    // add overlay to body
    e.preventDefault();
    if ($("#cart").hasClass("open")) {
      // Close cart
      $("#cart_overlay").hide(0).attr("aria-hidden", "true");
      $("#cart").removeClass("open");
      $("#attentive_overlay").show();
      $("body").removeClass("lock");
      
      // Return focus to element that opened cart
      if (lastFocusedElementBeforeCart) {
        lastFocusedElementBeforeCart.focus();
        lastFocusedElementBeforeCart = null;
      }
    } else {
      // Open cart
      lastFocusedElementBeforeCart = document.activeElement;
      
      // Hide cart content while loading to prevent flicker
      $("#cart .inner .items").css('opacity', '0');
      // Update cart data first, then open
      updateCartStuff(function() {
        $("#cart_overlay").show(0).attr("aria-hidden", "false");
        $("#cart").addClass("open");
        $("#attentive_overlay").hide();
        $("body").addClass("lock");
        // Show cart content after it's loaded
        $("#cart .inner .items").css('opacity', '1');
        
        // Focus first focusable element in cart (close button)
        setTimeout(function() {
          $("#cart").find("button.close").focus();
        }, 100);
      });
    }
  });
  
  // Focus trap for cart drawer
  $(document).on("keydown", function(e) {
    if (!$("#cart").hasClass("open")) return;
    
    if (e.key === "Tab" || e.keyCode === 9) {
      var focusableElements = $("#cart").find("a:visible, button:visible, input:visible, textarea:visible, select:visible, [tabindex]:visible").filter(function() {
        return $(this).is(":visible") && !$(this).is(":disabled") && $(this).attr("tabindex") !== "-1";
      });
      
      var firstFocusable = focusableElements.first()[0];
      var lastFocusable = focusableElements.last()[0];
      
      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
    
    // Escape key to close cart
    if (e.key === "Escape" || e.keyCode === 27) {
      if ($("#cart").hasClass("open")) {
        $(".toggle_cart").first().trigger("click");
      }
    }
  });

  // cart gift notes
  $("#cart .inner .notes a").on("click tap", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $("#cart_note").val("");
      $(this).removeClass("active");
      $("#cart_note").slideUp("fast");
    } else {
      $(this).addClass("active");
      $("#cart_note").slideDown("fast");
    }
  });
});

// home: feature + hero: feature
if ($('#home .feature').length) {
	$('#home .feature-carousel').slick({
		infinite: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 4500,
		arrows: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		fade: true
	})
}

if ($(".social-feed-videos__slider").length) {
  $(".social-feed-videos__slider")
    .imagesLoaded()
    .always(function () {
      $(".social-feed-videos__slider").slick({
        infinite: true,
        dots: false,
        arrows: true,
        variableWidth: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 2,
              centerMode: false
            },
          },
        ],
      });
    });
}

function resizeWindow() {
  var ww = $(window).width();
  var wh = $(window).height();

  // mobile nav height
  var hh = $("#header").outerHeight();
  if ($("#promo_bar").length) {
    var ph = $("#promo_bar").outerHeight();
    var hh = hh + ph;
    document.documentElement.style.setProperty("--announcement-bar-height", ph + "px");
    document.documentElement.style.setProperty("--announcement-bar-height-mobile", ph + "px");
    document.documentElement.style.setProperty("--header-height", (hh - ph) + "px");
    document.documentElement.style.setProperty("--mobile-header-height", (hh - ph) + "px");    
    $("#header").css({
      top: ph + "px",
    });
    $("#search_bar").css({
      top: ph + "px",
      "padding-top": ww > 1024 ? $("#header").outerHeight() : hh - 30 + "px",
    });
  } else {
    document.documentElement.style.setProperty("--header-height", hh + "px");
    document.documentElement.style.setProperty("--mobile-header-height", hh + "px");
  }
  var mh = wh - hh;
  $("#mobile_nav").css({
    height: mh + "px",
    top: hh + "px",
  });

  document.documentElement.style.setProperty("--mobileNavHeight", hh + "px");

  // home: feature + hero: feature
  if ($("#home .feature").length) {
    var hfh = $("#header").outerHeight();
    if ($("#promo_bar").length) {
      hfh = hfh + $("#promo_bar").outerHeight();
    }
    hfh = wh - hfh;
    $("#home .feature").css("height", hfh + "px");
    // $('#home .feature-carousel').slick({
    // 	infinite: true,
    // 	dots: true,
    // 	autoplay: true,
    // 	autoplaySpeed: 4500,
    // 	arrows: false,
    // 	pauseOnHover: false,
    // 	pauseOnFocus: false,
    // 	fade: true
    // })
  }
  if ($(".hero .feature").length) {
    var hfh = $("#header").outerHeight();
    if ($("#promo_bar").length) {
      hfh = hfh + $("#promo_bar").outerHeight();
    }
    hfh = wh - hfh;
    $(".hero .feature").each(function () {
      $(this).css("height", hfh + "px");
      $(this).find(".feature-carousel").slick({
        infinite: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4500,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        fade: true,
      });
    });
  }

  // home: collection
  // if ($("#home .collection .flex").length) {
  //   var $collection = $("#home .collection .flex");
  //   if (ww <= 1024) {
  //     if (!$collection.hasClass("slick-initialized")) {
  //       $collection.slick({
  //         dots: true,
  //         arrows: false,
  //         variableWidth: true,
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         adaptiveHeight: true,
  //       });
  //     }
  //   } else {
  //     if ($collection.hasClass("slick-initialized")) {
  //       $collection.slick("unslick");
  //     }
  //   }
  // }

  // home: categories
  // if ($("#home .categories .flex").length) {
  //   var $categories = $("#home .categories .flex");
  //   if (ww <= 768) {
  //     if (!$categories.hasClass("slick-initialized")) {
  //       $categories.slick({
  //         dots: true,
  //         arrows: false,
  //         variableWidth: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         adaptiveHeight: true,
  //         centerMode: true,
  //       });
  //     }
  //   } else {
  //     if ($categories.hasClass("slick-initialized")) {
  //       $categories.slick("unslick");
  //     }
  //   }
  // }

  // home: gallery
  if ($("#home .gallery .slider").length) {
    if ($("#home .gallery .slider").hasClass("slick-initialized")) {
      var imgH =
        $("#home .gallery .slider .slick-slide:first-child img").height() / 2;
      $("#home .gallery .slider .slick-arrow").css("top", imgH + "px");
    } else {
      $("#home .gallery .slider")
        .imagesLoaded()
        .always(function () {
          $("#home .gallery .slider").on("init", function () {
            var imgH =
              $(
                "#home .gallery .slider .slick-slide:first-child img"
              ).height() / 2;
            $("#home .gallery .slider .slick-arrow").css("top", imgH + "px");
          });
          $("#home .gallery .slider").slick({
            infinite: true,
            dots: false,
            arrows: true,
            variableWidth: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: 0,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  variableWidth: true,
                },
              },
            ],
          });
        });
    }
  }

  // causes carousel
  if ($(".causes .causes-slider").length) {
    $(".causes .causes-slider")
      .imagesLoaded()
      .always(function () {
        $(".causes .causes-slider").slick({
          infinite: true,
          dots: false,
          arrows: false,
          variableWidth: false,
          autoplay: true,
          autoplaySpeed: 2500,
          slidesToShow: 6,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 580,
              settings: {
                slidesToShow: 3,
                centerMode: true,
              },
            },
          ],
        });
      });
  }

  // faq: sidebar
  if ($("#faqs").length) {
    if (ww > 768) {
      var theOffset = 60;
      if (ww > 1024) {
        theOffset = -50;
      }
      $("#faqs .sections .flex .flex-item.sidebar").stick_in_parent({
        offset_top: theOffset,
      });
    } else {
      $("#faqs .sections .flex .flex-item.sidebar").trigger(
        "sticky_kit:detach"
      );
    }
  }

  if ($(".image_text-carousel").length) {
    $(".image_text-carousel").each(function () {
      $(this).slick({
        infinite: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        fade: true,
      });
    });
  }
}

function addItem(form_id) {
	$.ajax({
	   type: 'POST',
	   url: '/cart/add.js',
	   dataType: 'json',
	   data: $('#' + form_id).serialize(),
	   success: function(product) {
		 // Hide cart content while loading to prevent flicker
		 $('#cart .inner .items').css('opacity', '0');
		 updateCartStuff(function() {
		   $('#cart_overlay').show(0).attr("aria-hidden", "false");
		   $('#cart').addClass('open');
		   $('body').addClass('lock');
		   // Show cart content after it's loaded
		   $('#cart .inner .items').css('opacity', '1');
		   
		   // Focus the close button in the cart
		   setTimeout(function() {
		     $('#cart button.close').focus();
		   }, 100);
		 });
	   },
	   error: function(obj, status) {
		   alert('The product you are trying to add is out of stock.');
	   }
   });
}

// Custom element for <add-to-cart> component - helper for nested form elements. 
class AddToCart extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button[type="submit"]');
    if (this.button) {
      // Store original button text
      this.originalButtonText = this.button.textContent.trim();
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleAddToCart();
      });
    }
  }

  handleAddToCart() {
    const variantId = this.getAttribute('data-variant-id');
    const quantity = this.getAttribute('data-quantity') || '1';
    
    if (!variantId) {
      alert('Variant ID is missing.');
      return;
    }

    // Update button text to "Adding..."
    if (this.button) {
      this.button.textContent = 'Adding...';
      this.button.disabled = true;
    }

    const formData = {
      id: variantId,
      quantity: parseInt(quantity, 10)
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: formData,
      success: (product) => {
        // Restore original button text
        if (this.button) {
          this.button.textContent = this.originalButtonText;
          this.button.disabled = false;
        }
        // Hide cart content while loading to prevent flicker
        $('#cart .inner .items').css('opacity', '0');
        updateCartStuff(function() {
          $('#cart_overlay').show(0).attr("aria-hidden", "false");
          $('#cart').addClass('open');
          $('body').addClass('lock');
          // Show cart content after it's loaded
          $('#cart .inner .items').css('opacity', '1');
          
          // Focus the close button in the cart
          setTimeout(function() {
            $('#cart button.close').focus();
          }, 100);
        });
      },
      error: (obj, status) => {
        // Restore original button text
        if (this.button) {
          this.button.textContent = this.originalButtonText;
          this.button.disabled = false;
        }
        alert('The product you are trying to add is out of stock.');
      }
    });
  }
}

// Register the custom element
if (!customElements.get('add-to-cart')) {
  customElements.define('add-to-cart', AddToCart);
}
 
// Helper function to restore focus after cart updates
function restoreCartFocus(context) {
  if (!context) return;
  
  setTimeout(function() {
    if (context.action === 'remove') {
      // After removing an item, focus the close button to keep focus in cart
      $("#cart button.close").focus();
    } else if (context.action === 'add' || context.action === 'subtract') {
      // Try to focus the same button that was clicked
      var $item = $("#cart .inner .items .item").filter(function() {
        return $(this).find('[onclick*="' + context.key + '"]').length > 0;
      });
      
      if ($item.length) {
        if (context.action === 'add') {
          $item.find("button.plus").focus();
        } else {
          $item.find("button.minus").focus();
        }
      } else {
        // Item not found, focus close button
        $("#cart button.close").focus();
      }
    }
  }, 100);
}

function cartSubtract(line_item_key, qty) {
   // Save focus context
   var focusContext = {
     action: 'subtract',
     key: line_item_key
   };

   var newQty = qty - 1;
   var data = 'updates[' + line_item_key + ']=' + newQty;

   $.ajax({
	   type: 'POST',
	   url: '/cart/update.js',
	   data: data,
	   dataType: 'json',
	   success: function(cart) {
		 updateCartStuff(function() {
       // Restore focus to the same item's minus button
       restoreCartFocus(focusContext);
     });
	   },
	   error: function() {
		 alert('There was an error.');
	   }
   });

}
 
function cartAdd(line_item_key, qty) {
   // Save focus context
   var focusContext = {
     action: 'add',
     key: line_item_key
   };

   var newQty = qty + 1;
   var data = 'updates[' + line_item_key + ']=' + newQty;

   $.ajax({
	   type: 'POST',
	   url: '/cart/update.js',
	   data: data,
	   dataType: 'json',
	   success: function(cart) {
		 updateCartStuff(function() {
       // Restore focus to the same item's plus button
       restoreCartFocus(focusContext);
     });
	   },
	   error: function() {
		 alert('There was an error.');
	   }
   });

}
 
function cartRemove(line_item_key, line_item_handle) {
   // Save focus context - will focus close button after removal
   var focusContext = {
     action: 'remove',
     key: line_item_key
   };

   var data = 'updates[' + line_item_key + ']=0';

   $.ajax({
	   type: 'POST',
	   url: '/cart/update.js',
	   data: data,
	   dataType: 'json',
	   success: function(cart) {
		 updateCartStuff(function() {
       // After removing item, focus the close button or first focusable element
       restoreCartFocus(focusContext);
     });
	   },
	   error: function() {
		 alert('There was an error.');
	   }
   });
   
}

function detectNotes() {
	var notes = $('#cart_note').val();
	cartNotes(notes);
}

function cartNotes(note) {
  
	var notes = $.trim(note);

	var data = 'note=' + notes;

	$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		data: data,
		dataType: 'json'
	}).done(function(data) {
		updateCartStuff();
	});

}
 
function updateCartStuff(callback) {
	
   $.ajax({
	 
	   type: 'GET',
	   url: '/cart.js',
	   dataType: 'json',
	   success: function(cart) { 
		 
     window.cart = cart;
		 
		 $('#cart .inner .items').html('');

		 var items_count = 0;

		 var additionalFees = '';
		 var found_gift_fees = 0;
		 var item_has_ring_sizer = false;
		 var cart_has_ring_sizer_prod = false;
		 var cart_ring_sizer_key = "";
		 var needed_gift_fees = 0;
		 var stud_club_gift_note = false;
		 
		 // Handle cart-level discounts
		 if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
			// Calculate original price before discount
			var originalPrice = cart.total_price + cart.total_discount;
			var subtotalHtml = (Shopify.formatMoney(cart.total_price)).replace('.00','') + ' <s>' + (Shopify.formatMoney(originalPrice)).replace('.00','') + '</s> ';
			$('#cart .subtotal .total_price').html(subtotalHtml);
			
			var discountHtml = 'Discount';
			if (cart.cart_level_discount_applications.length === 1) {
				discountHtml += ' <span class="discount-label">(' + cart.cart_level_discount_applications[0].title + ')</span>';
			}
			$('#cart .bottom .discount .subtotal_text').html(discountHtml);
			$('#cart .bottom .discount .total_price').html('-' + (Shopify.formatMoney(cart.total_discount)).replace('.00',''));
			$('#cart .bottom .discount').show(0);
		 } else {
			$('#cart .subtotal .total_price').html((Shopify.formatMoney(cart.total_price)).replace('.00',''));
			$('#cart .bottom .discount').hide(0);
		 }

		 // Update free shipping bar when available
		 if (typeof handleFreeShippingBar === 'function') {
			 handleFreeShippingBar(cart);
		 }
		 
		 if (cart.attributes) {
			if (cart.attributes.hasOwnProperty('Gift Message')){
				var message = cart.attributes['Gift Message'];
				if (message != '') {
					$('#gift_message').val(message);
          console.log('message: ' + message);
					$('#cart .bottom .gift_message_text a span').text('Edit Gift Message');
					$('#cart .bottom .gift_message_text a').show(0);
					$('#cart .bottom .gift_message_update').hide(0);
					// ... and fallback cart
					if ($('#shopping_cart').length) {
						$('#gift_message_cart').val(message);
						$('#shopping_cart .gift_message_text span').text(message);
					$('#shopping_cart .gift_message_text a').text('edit').show(0);
					$('#shopping_cart .gift_message_update').hide(0);
				}
			}
			}
		 }
 
		 if (cart.item_count > 0) {
		   
		   $.each(cart.items, function(index, cartItem) {
 
			if (cartItem.title != 'Item Personalization') {

				items_count += cartItem.quantity;
 
				var item = '';

				if(ring_sizer_enabled){
					if (cartItem.properties) {
						if (cartItem.properties.hasOwnProperty('_Ring Sizer')){
							item_has_ring_sizer = true;
						}
					}
					if(cartItem.handle === ring_sizer_handle){
						cart_has_ring_sizer_prod = true;
						cart_ring_sizer_key = cartItem.key
					}
				}

				if (cartItem.handle == gift_wrapping_handle) {

					if (gift_wrapping_enabled) {
						found_gift_fees += cartItem.quantity;
						additionalFees += (Shopify.formatMoney(cartItem.price)).replace('.00', '') + ' x ' + cartItem.quantity;
					}
					
				} else {

					if (gift_wrapping_enabled) {
						if (cartItem.properties) {
							if (cartItem.properties.hasOwnProperty('Gift Wrapped')){
								if(cartItem.title.includes("Stud Club")){
									stud_club_gift_note = true;
								} else {
									needed_gift_fees += cartItem.quantity;
								}
							}
						}
					}
									
					item += '<div class="item item-' + cartItem.variant_id + '">';
						item += '<div class="flex items-center">';
							item += '<div class="flex-item thumb">';
              if (cartItem.properties.hasOwnProperty('_free_gift')){
                if(window.freeGiftURL !== undefined){
                  item += '<a href="' + window.freeGiftURL + '">';
                    item += '<img src="' + cartItem.image + '" alt="" width="143" />';
                  item += '</a>';
                } else {
                  item += '<div>';
                    item += '<img src="' + cartItem.image + '" alt="" width="143" />';
                  item += '</div>';
                }
              } else {
                item += '<a href="' + cartItem.url + '">';
                  item += '<img src="' + cartItem.image + '" alt="" width="143" />';
                item += '</a>';
              }
							item += '</div>';
							item += '<div class="flex-item details">';
              if (cartItem.properties.hasOwnProperty('_free_gift')){
                if(window.freeGiftURL !== undefined){
                  item += '<span class="title"><a href="' + window.freeGiftURL + '">' + cartItem.product_title + '</a></span>';
                } else {
                  item += '<span class="title"><div>' + cartItem.product_title + '</div></span>';
                }
              } else {
								item += '<span class="title"><a href="' + cartItem.url + '">' + cartItem.product_title + '</a></span>';
              }
								if (cartItem.variant_options.length > 0) {
									$.each(cartItem.variant_options, function(i,o) {
										if (o != 'Default Title') {
											var optionLabel = cartItem.options_with_values[i].name;
											item += '<span class="option maison_neue_book">' + optionLabel + ': ' + o + '</span>';
										}
									});
								}
								if (cartItem.properties) {
									$.each(cartItem.properties, function(i, o) {
                    if(!i.startsWith("_")){
                      if (i == 'Made To Order') {
                        if(o.length){
                          item += '<span class="option alt pink">Ships in ' + o + '</span>';
                        }
                      } else {
                        if (i == 'Gift Wrapped') {
                          if(!cartItem.title.includes("Stud Club")){
                            item += `<div class="gift-wrapping">
                              <label>         
                                <span class="text option alt pink">Gift Wrapped</span>
                                <input type="checkbox" checked data-key="${cartItem.key}">
                                <span class="checkmark"></span>
                              </label>
                            </div>`;
                          }
                        } else if (i == 'Final Sale') {
                          item += '<span class="option alt pink">Final Sale</span>';
                        } else if (i == 'Sale') {
                          item += '<span class="option alt pink">Sale</span>';
                        } else if( i == '_Ring Sizer' ) {
                          item += '<span class="option alt pink">Added Ring Sizer</span>';
                        } else {
                          if (!i.includes('_pplr_') && !i.includes('_pc_') && !i.includes('Preview') && o.length) {
                            item += '<span class="option alt">' + i + ': ' + o + '</span>';
                          }
                        }
                      }                                        
                    }
									});
								}

								if (cartItem.properties) {
									if (!cartItem.properties.hasOwnProperty('Gift Wrapped') && cartItem.properties.hasOwnProperty('_Gift Wrapping Available')){
                     item += `<div class="gift-wrapping">
                        <label>         
                          <span class="text option alt pink">Add gift wrapping +$5</span>
                          <input type="checkbox" data-key="${cartItem.key}">
                          <span class="checkmark"></span>
                        </label>
                      </div>`;
                  }
								}

                if (cartItem.discounts) {
                    $.each(cartItem.discounts, function (i, o) {
                        if (o != '') {
                            item += '<span class="option alt pink"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style="width:15px;height:15px;position:relative;top:4px;margin-right:4px;"><path d="M10.408 3h5.592a1 1 0 0 1 1 1v5.592a2 2 0 0 1-.57 1.399l-5.162 5.277a2.5 2.5 0 0 1-3.536 0l-4-4a2.5 2.5 0 0 1 0-3.536l.008-.008 5.27-5.154a2 2 0 0 1 1.397-.57Zm3.092 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill="currentColor" /></svg>' + o.title + '</span>';
                        }
                    });
                }     

								if(cartItem.handle !== ring_sizer_handle){

                  item += '<div class="flex-item price maison_neue_book">';
                  if (cartItem.properties) {
                    if (cartItem.properties.hasOwnProperty('_free_gift')){
                      item += "<div>FREE</div>";
                    } else if (cartItem.properties.hasOwnProperty('_pc_pricing_qty')){
                      item += (Shopify.formatMoney(cartItem.properties['_pc_pricing_qty'])).replace('.00','');
                    } else {
                      if(cartItem.discounted_price < cartItem.price){
                        item += "<div class='display:flex;flex-wrap:wrap;justify-content:flex-end;'><s>" + (Shopify.formatMoney(cartItem.price)).replace('.00','') + "</s><span style='display:inline-block;margin-left: 2px;'>" + Shopify.formatMoney(cartItem.discounted_price).replace('.00','') + "</span></div>";
                      } else {
                        item += (Shopify.formatMoney(cartItem.price)).replace('.00','');
                      }
                    }
                  } else {
                    if(cartItem.discounted_price < cartItem.price){
                      item += "<div class='display:flex;flex-wrap:wrap;justify-content:flex-end;'><s>" + (Shopify.formatMoney(cartItem.price)).replace('.00','') + "</s><span style='display:inline-block;margin-left: 2px;'>" + Shopify.formatMoney(cartItem.discounted_price).replace('.00','') + "</span></div>";
                    } else {
                      item += (Shopify.formatMoney(cartItem.price)).replace('.00','');
                    }
                  }
                  item += '</div>';


                  if (cartItem.properties.hasOwnProperty('_free_gift')){
                    item += '<a href="#" onclick="window.handleGiftRemoval(' + cartItem.variant_id + ')" class="free-gift-remove">Remove Free Gift</a>';
                  }
                  if (!cartItem.properties.hasOwnProperty('_free_gift')){
                    item += '<div class="line-item__actions">';
                    item += '<div class="qty">';
                    item += '<button class="minus" onclick="cartSubtract(\'' + cartItem.key + '\', ' + cartItem.quantity + '); return false;">&ndash;</button>';
                    item += '<span class="amount">' + cartItem.quantity + '</span>';
                    item += '<button class="plus" onclick="cartAdd(\'' + cartItem.key + '\', ' + cartItem.quantity + '); return false;">+</button>';
                    item += '</div>';
                    if (!cartItem.properties.hasOwnProperty('_free_gift')){
                      item += '<a href="#" onclick="cartRemove(\'' + cartItem.key + '\', \'' + cartItem.handle + '\')" class="remove maison_neue_medium uppercase">Remove</a>';
                    }
                    item += '</div>';
                  }
								} else {
									item += "<span class='option alt pink'>" + ring_sizer_cart_text + "</span>"
								}
							item += '</div>';
						item += '</div>';
					item += '</div>';
							
				}

				$('#cart .inner .items').append(item);

        if($(`#cart .item-${cartItem.variant_id} .gift-wrapping`).length){

          var giftWrapToggled;
          $(`#cart .item-${cartItem.variant_id} .gift-wrapping input`).on("change", function(e){
            
            var giftWrappingHandle = "gift-wrapping-fee";
            var giftWrappingItem = window.cart.items.find(item => item.handle === giftWrappingHandle)
    
            let $cartItemEl = $(this).parents(".item")
            $cartItemEl.addClass("item--loading");
            var updatedProperties = { ...cartItem.properties };

            if ($(`#cart .item-${cartItem.variant_id} .gift-wrapping input`)[0].checked) {
                updatedProperties["Gift Wrapped"] = "true";
                giftWrapToggled = true;
            } else {
                delete updatedProperties["Gift Wrapped"];
                giftWrapToggled = false;
            }
            
            var data = {
                id: cartItem.key,
                properties: updatedProperties
            };

            
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                success: function() {

                    if(giftWrappingItem === undefined){

                      var giftData = {
                        'items': [{
                          'id': giftWrappingVariantID,
                          'quantity': 1
                          }]
                      }
                      $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        contentType: 'application/json',
                        data: JSON.stringify(giftData),
                        dataType: 'json',
                        success: function() {
                          updateCartStuff();
                        },
                        error: function(xhr, status, error) {
                          console.error('Error updating cart:', error);
                        } 
                      })                      
                    
                    } else {

                      var giftData = {
                        id: giftWrappingItem.key,
                        quantity: giftWrapToggled ? giftWrappingItem.quantity + 1 : giftWrappingItem.quantity - 1
                      }
                      $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: giftData,
                        dataType: 'json',
                        success: function() {
                          updateCartStuff();
                        },
                        error: function(xhr, status, error) {
                          console.error('Error updating cart:', error);
                        } 
                      })
                    
                    }

                },
                error: function(xhr, status, error) {
                    console.error('Error updating cart:', error);
                }
            });
            
          }) 
        }

			}

		   });

		   if (gift_wrapping_enabled) {
				if (needed_gift_fees > 0) {
					if (needed_gift_fees != found_gift_fees) {
						updateGiftWrappingFee(needed_gift_fees);
					}
					$('#cart .bottom .additional_fees .total_price').html(additionalFees);
					$('#cart .bottom .additional_fees').show(0);
					$('#cart .bottom .gift_message').show(0);
					// ... and fallback cart
					if ($('#shopping_cart').length) {
						$('#shopping_cart .additional_fees').html(additionalFees);
						$('#shopping_cart .additional_fees').show(0);
						$('#shopping_cart .gift_message').show(0);
					}
				} else {
					$('#cart .bottom .additional_fees .total_price').html('');
					$('#cart .bottom .additional_fees').hide(0);
					$('#cart .bottom .gift_message').hide(0);
					// ... and fallback cart
					if ($('#shopping_cart').length) {
						$('#shopping_cart .additional_fees').html('');
						$('#shopping_cart .additional_fees').hide(0);
						$('#shopping_cart .gift_message').hide(0);
					}
					if (found_gift_fees > 0) {
						updateGiftWrappingFee(0);
					}
				}			
		   }

			if(stud_club_gift_note){
				$('#cart .bottom .gift_message').show(0);
				// ... and fallback cart
				if ($('#shopping_cart').length) {
					$('#shopping_cart .gift_message').show(0);
				}
			} else {
				if(needed_gift_fees === 0){
					$('#cart .bottom .gift_message').hide(0);
					// ... and fallback cart
					if ($('#shopping_cart').length) {
						$('#shopping_cart .gift_message').hide(0);
					}
				}
			}

		   if(ring_sizer_enabled){
				if(item_has_ring_sizer && !cart_has_ring_sizer_prod){
					addRingSizerProduct();
				}
				if(!item_has_ring_sizer && cart_has_ring_sizer_prod){
					removeRingSizerProduct(cart_ring_sizer_key)
				}
			}

			// UPSELLS - always re-render cart-drawer section (Liquid decides content)
			updateCartUpsells();

		   $('#cart .notes').show(0);
		   $('#cart .bottom').show(0);
		   
		 } else {
 
       const collections = window.emptyCartCollections || [];
       const $cartItems = $('#cart .inner .items');
       const $cartDrawerFooter = $('#cart .bottom');
				
       // Create collection HTML nodes from collection objects
       const collectionsHTML = collections.length > 0 ? collections.map(collection => {
         return `<div class="cart__drawer-empty-cart-collections-item">
           <a href="${collection.url}" class="cart__drawer-empty-cart-collections-item-inner">
             <div class="overflow-hidden">
               <img src="${collection.image}" alt="View ${collection.title} collection" class="collection-image w-full h-full object-cover"/>
             </div>
             <div class="cart__drawer-empty-cart-collections-item-text">
                <span class="cart__drawer-empty-cart-collections-item-title ivy_presto">${collection.title}</span>
                <span class="cart__drawer-empty-cart-collections-item-view maison_neue_medium">Shop ${collection.title}</span>
             </div>
           </a>
         </div>`;
       }).join('') : '';
       
       $cartItems.html(`<div class="cart__drawer-empty-cart-inner text-center">
         <p class="centertext heading ivy_presto">${window.emptyCartHeadline || 'Your cart is empty'}</p>
         <p class="cart__drawer-empty-subtext">${window.emptyCartSubheadline || ''}</p>
         ${collectionsHTML ? `<div class="cart__drawer-empty-cart-collections">${collectionsHTML}</div>` : ''}
         ${window.emptyCartButtonURL ? `<div class="cart__drawer-empty-cart-button">
           <a href="${window.emptyCartButtonURL}" class="button">${window.emptyCartButtonText || 'Shop Now'}</a>
           ${window.shippingMessage ? `<div class="cart__drawer-empty-cart-shipping-message">
             <p class="cart__drawer-empty-cart-shipping-message-text maison_neue_book">${window.shippingMessage}</p>
           </div>` : ''}
         </div>` : ''}
       </div>`);
       $cartDrawerFooter.hide();
 
		   $('#cart .notes').hide(0);
		   $('#cart .bottom').hide(0);

			// UPSELLS
			if($(".upsell-items").length){
				$(".upsell-items").hide();
			}	
 
		 }
		 
		 if (found_gift_fees > 0) {
			$('.cart_count').html(items_count - found_gift_fees);
      $('.cart-count').html('(' + (items_count - found_gift_fees) + ')');
		 } else {
			$('.cart_count').html(items_count);
      $('.cart-count').html('(' + items_count + ')');
			// remove cart attribute for "Gift Message"
			if (gift_wrapping_enabled && !stud_club_gift_note) {
				$.ajax({
					type: 'POST',
					url: '/cart/update.js',
					data: 'attributes[Gift Message]=',
					dataType: 'json'
				});
			}
		 }	

		 if(!stud_club_gift_note && found_gift_fees < 1){
        $('#cart .bottom .additional_fees .total_price').html('');
        $('#cart .bottom .additional_fees').hide(0);
        $('#cart .bottom .gift_message').hide(0);
        // ... and fallback cart
        if ($('#shopping_cart').length) {
          $('#shopping_cart .additional_fees').html('');
          $('#shopping_cart .additional_fees').hide(0);
          $('#shopping_cart .gift_message').hide(0);
        }
      }

      // Dispatch extra custom event to signal that the cart has been updated 
			// window.addEventListener('cartUpdated', (event) => { ... }
			const cartUpdatedEvent = new CustomEvent('cartUpdated', { detail: cart });
			window.dispatchEvent(cartUpdatedEvent);		
		 
      // Call callback if provided
      if (typeof callback === 'function') {
        callback();
      }
	  }
				
   });
   
}